import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useToast } from "./ui/use-toast";

/** Shared template tools live in the app rather than on the marketing website. */
export function HandoffReturnNotice() {
  const [params, setParams] = useSearchParams();
  const { toast } = useToast();
  useEffect(() => {
    if (params.get("handoff") !== "retry") return;
    toast({
      description:
        "Your session expired or couldn’t be restored. Please try again.",
      duration: 12000,
    });
    const next = new URLSearchParams(params);
    next.delete("handoff");
    setParams(next, { replace: true });
  }, [params, setParams, toast]);
  return null;
}
